import React, { useEffect, useState } from 'react';
import get from 'lodash/get';
import { phrases, validator } from 'myValidation';
import { InputLabel, FormHelperText } from '@mui/material';
import { LabelWithToolTip } from 'components';
import { useFormContext } from 'react-hook-form';
import { LabelLine } from './components';
import { useStyles } from './style';

const FieldWrapper = (props) => {
  const classes = useStyles();
  const {
    name,
    errors,
    rules,
    label,
    labelStyle,
    asterisk = true,
    infoText = null,
    infoType = null,
    tooltip,
    showLabel = true,
    children,
  } = props;

  const [showAsterisk, setShowAsterisk] = useState(false);
  const [fieldError, setFieldError] = useState(null);
  const formContext = useFormContext();
  const formState = formContext?.formState ?? null;

  useEffect(() => {
    const tempErr = formState?.errors ?? errors ?? null;

    const updateErrors = (incomingErr) => {
      let newErr = false;
      if (rules) {
        newErr = get(incomingErr, name, false);
      }
      setFieldError(newErr ?? null);
    };

    if (tempErr) {
      updateErrors(tempErr);
    }
  }, [formState, errors, rules, name]);

  // --LOCAL VARIABLES--//

  useEffect(() => {
    let vv = {};
    if (rules && rules.length > 0) {
      rules.forEach((item) => {
        if (item.includes('|')) {
          let [funcName, options] = item.split('|');
          const func = validator.validators[funcName];

          if (options.includes('{')) {
            options = JSON.parse(options);
          }

          vv[item] = (value) => {
            if (!func(value, options)) {
              return phrases[funcName].replace(':attribute', label).replace(':param', options);
            }
            return true;
          };
        } else {
          if (item === 'required' && asterisk) {
            setShowAsterisk(true);
          }

          const func = validator.validators[item];
          vv[item] = (value) =>
            !func(String(value)) ? phrases[item].replace(':attribute', label) : true;
        }
      });
    } else {
      setShowAsterisk(false);
    }
    if (rules && !rules.find(a => a === "required")) {
      setShowAsterisk(false);
    }
  }, [asterisk, label, rules]);

  // --FUNC--//

  return (
    <div>
      {showLabel ? (
        <InputLabel
          shrink
          htmlFor={`bootstrap-input${name}`}
          className={classes.label}
          style={{ ...labelStyle }}
        >
          <LabelLine
            label={<LabelWithToolTip label={label} description={tooltip} />}
            infoText={infoText}
            infoType={infoType}
            required={showAsterisk}
          />
        </InputLabel>
      ) : null}

      {children}

      <FormHelperText id="my-helper-text" style={{ color: 'red', minHeight: 13 }}>
        {fieldError?.message ?? null}
      </FormHelperText>
    </div>
  );
};

export default FieldWrapper;
